module.exports = __webpack_public_path__ + "img/branco2.862546bd.png";